import { AxiosError } from "axios";
import { getAuth } from "firebase/auth";
import client from "../../api/client";
import TApiResult from "../../types/api/TApiResult";
import getErrorProperty from "./config/getErrorProperty";
import tokenNotFound from "./config/tokenNotFound";
import { UpdatePinnedCommentStatusParams, UpdatePinnedCommentStatusResponse } from "../../api/pinned_comment";

export type TApiPutBoardComment = {
  result?: UpdatePinnedCommentStatusResponse;
};

export const putPinnedStatus = async (
    body: UpdatePinnedCommentStatusParams
): Promise<TApiResult & TApiPutBoardComment> => {
  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  if (!token) return tokenNotFound;
  return await client()
    .board_comment.pinned.put({
      body,
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      return {
        isSuccess: true,
        status: 200,
        message: "",
        result: res.body
      };
    })
    .catch((e: AxiosError) => {
      const { status, message } = getErrorProperty(e, "putPinnedStatus");
      return {
        isSuccess: false,
        status: status,
        message: message,
      };
    });
};
